import React from 'react'
import FieldWrapper from '../Common/FieldWrapper'

export default class DateInHistory extends FieldWrapper {

  touched = [
    false,
    false,
    false
  ]

  getValues() {
    const {
      formikField,
      config
    } = this.props
    const {
      valueSplitter
    } = config

    const value = (formikField.value || '').split(valueSplitter)
    return [
      value.length >= 1 ? value[0] : '',
      value.length >= 2 ? value[1] : '',
      value.length >= 3 ? value[2] : ''
    ]
  }

  onChange = (e, valuesIndex) => {
    const { 
      formikForm,
      formikField: { name },
      config: { valueSplitter }
    } = this.props

    const values = this.getValues()
    values[valuesIndex] = e.currentTarget.value

    const value = values.join(valueSplitter)

    formikForm.setFieldValue(name, value, true)
  }

  focusNextInputIfCompleted(values, placeholder, e, i) {
    if (
      (i + 1 >= values.length) ||
      e.currentTarget.value.length !== placeholder[i].length
    ) {
      return
    }

    try {
      e.currentTarget.parentNode.nextSibling.nextSibling.firstChild.focus()
    } catch (ex) {
      console.warn('Unable to find next DateInHistory input element')
    }
  }

  onBlur = (inputIndex) => {
    if (this.touched[inputIndex]) return
    this.touched[inputIndex] = true

    const values = this.getValues()
    this.checkTouched(values)
    if (this.touched.filter(t => t).length !== 3) return

    this.setTouched();
  }

  checkTouched(values) {
    values.forEach((value, i) => {
      if (!this.touched[i])
        this.touched[i] = !!value[i]
    })
  }

  setTouched() {
    const formikForm = this.props.formikForm
    const name = this.props.formikField.name
    formikForm.setFieldTouched(name, true)
  }

  renderField() {
    const {
      config,
      formikField,
      isRequired
    } = this.props
    let {
      label,
      placeholder,
      valueSplitter,
      displaySplitter,
      readOnly,
      disabled
    } = config

    const classes = ["field__birthdate-day", "field__birthdate-month", "field__birthdate-year"]
    const values = this.getValues()
    placeholder = placeholder.split(valueSplitter)

    return (
      <div className="field__birthdate">
        {
          values.map((value, i) => <React.Fragment key={i}>
            <div className={`field__input-container ${classes[i]}`}>
              <input
                className="field__input"
                value={value}
                type="tel"
                placeholder={placeholder[i]}
                aria-label={`${label}: ${placeholder[i]}`}
                aria-required={!!isRequired}
                readOnly={!!readOnly}
                disabled={!!disabled}
                maxLength={placeholder[i].length}
                onChange={(e) => {
                  this.onChange(e, i)
                  this.focusNextInputIfCompleted(values, placeholder, e, i)
                }}
                onBlur={() => this.onBlur(i)} />
            </div>
            {
              i >= 2 ? null :
                <div className="field__birthdate-splitter">{displaySplitter || ''}</div>
            }
          </React.Fragment>
          )
        }

        <input
          type="hidden"
          {...formikField}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/DateInHistory.js